var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-sliders-horizontal-icon lucide-sliders-horizontal",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    x2: 14,
    y1: 4,
    y2: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    x2: 3,
    y1: 4,
    y2: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    x2: 12,
    y1: 12,
    y2: 12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    x2: 3,
    y1: 12,
    y2: 12
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    x2: 16,
    y1: 20,
    y2: 20
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    x2: 3,
    y1: 20,
    y2: 20
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    x2: 14,
    y1: 2,
    y2: 6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    x2: 8,
    y1: 10,
    y2: 14
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    x2: 16,
    y1: 18,
    y2: 22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.8d22d3a035c4b97cadc95d25fd370632.svg";
export { ForwardRef as ReactComponent };